










import { Vue, Component } from "vue-property-decorator";
import courses, { CourseV2ListParams } from "@/getinfo-api/courseV2";
import registration, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { CourseList as ICourseList } from "@/api-v2/course/models";
import { getCurrentCompanyId, getCurrentUserId } from "@/plugins/roles";
import { uniqBy } from "lodash";

@Component({ components: {} })
export default class CourseV2List extends Vue {
  courses: ICourseList = {
    items: [],
    count: 0
  };

  get currentCompany() {
    return getCurrentCompanyId();
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  created() {
    let courseForm: CourseV2ListParams = {
      limit: 999,
      sort: "createdAt",
      order: "DESC",
      companyId: this.currentCompany
    };
    courses(courseForm).then(res => {
      this.courses.items = [...this.courses.items, ...res.data.items];
      this.courses.items = uniqBy(this.courses.items, "id");
    });
    let registrationForm: CourseRegistrationsListParams = {
      limit: 999,
      studentUserIds: [this.currentUserId]
    };
    registration(registrationForm).then(res => {
      let courses = res.data.items.map(el => el.course);
      this.courses.items = [...this.courses.items, ...courses];
      this.courses.items = uniqBy(this.courses.items, "id");
    });
  }
}
